import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faEdit } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useGetBrandsbyIdQuery } from "../../Services/BrandsAPI";
import { useParams } from "react-router-dom";


function AddCategory() {
    const { id } = useParams();
    const [categoryName, setCategoryName] = useState("");
    const [categoryImage, setCategoryImage] = useState(null);
    const [description, setDescription] = useState("");


    const { data: categoryDetail, isLoading: loadingContent, error, refetch: refetchCategoryDetail } = useGetBrandsbyIdQuery(id);


    useEffect(() => {
        refetchCategoryDetail();
    },[refetchCategoryDetail])

    useEffect(() => {
        console.log("categoryDetail?.data?.parent_id", categoryDetail?.data?.parent_id);
        setCategoryName(categoryDetail?.brand?.name);
        setDescription(categoryDetail?.brand?.description);
    }, [categoryDetail])

    useEffect(()=>{
        console.log("categoryImage",categoryImage);

    }, [categoryImage])


    if (loadingContent) return <div class="loader"></div>;
    if (error) return <p>Failed to load Data</p>;

    return (
        <div>
            <h3>View Brand</h3>
            <div className="breadcrum mb-4">
                <p>
                    <Link to="/list-brands"><span>Brands</span></Link>
                    <FontAwesomeIcon icon={faAngleRight} className="mx-2" />
                    <span className="active-link">View</span>
                </p>
            </div>
            <div className="text-end">
                <Link  to={`/edit-brands/${id}`}><button className="btn-primary mb-4"><FontAwesomeIcon
                    icon={faEdit}
                    className="text-primary mx-2"
                />Edit</button></Link>
            </div>
            <div className="content-wrapper">
            <form  encType="multipart/form-data">
                    <div className="row">
                        {/* Category Name */}
                        <div className="col-md-6 col-sm-12 col-lg-6">
                            <div className="mb-4 text-start">
                                <label htmlFor="category_name" className="form-label">Brand Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="category_name"
                                    placeholder="Enter Category Name"
                                    value={categoryName}
                                    onChange={(e) => setCategoryName(e.target.value)}
                                />
                              
                            </div>
                        </div>


                        {/* Description */}
                        <div className="col-md-12 col-sm-12 col-lg-12">
                            <div className="mb-4 text-start">
                                <label htmlFor="description" className="form-label w-100">Description</label><br />
                                <textarea
                                    rows={4}
                                    name="description"
                                    className="form-control"
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                />
                             
                            </div>
                        </div>

                        {/* Category Image */}
                        <div className="col-md-6 col-sm-12 col-lg-6 d-block">
                            <div className="text-start">
                                <label htmlFor="category_image" className="form-label"> Image</label>
                                <input
                                    type="file"
                                    className="form-control"
                                    id="category_image"
                                    onChange={(e) => setCategoryImage(e.target.files[0])}
                                />
                            </div>
                            <img src={categoryDetail?.brand?.image} className="category-edit-img" alt="img" />
                        </div>

                    </div>


                </form>
            </div>
        </div>
    );
}

export default AddCategory;
